import React, { useState } from 'react';

import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';

import StudentBlock from 'pages/LiveClassroom/components/StudentBlock/index';
import StudentWorkDialog from 'pages/LiveClassroom/components/StudentWorkDialog/index';

import styles from './style.module.scss';

const StudentsOverview = ({ students }) => {
  const [selectedStudent, setSelectedStudent] = useState(null);
  return (
    <div className={styles.overview}>
      <div className={styles.heading}>
        <div className={styles.icon}>
          <PeopleAltOutlinedIcon style={{ fontSize: 38 }} />
        </div>
        <span className={styles.title}>Student Progress</span>
      </div>

      <div className={styles.grid}>
        {students.map((student, index) => (
          <StudentBlock
            key={index}
            student={student}
            isSelected={selectedStudent === student}
            onClick={(student) => setSelectedStudent(student)}
          />
        ))}
      </div>
      <StudentWorkDialog
        open={
          Boolean(selectedStudent) && selectedStudent?.work_files?.length > 0
        }
        onClose={() => setSelectedStudent(null)}
        urls={selectedStudent?.work_files}
      />
    </div>
  );
};

export default StudentsOverview;
